import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/homepage';

export default function HotArticlesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex items-center justify-between mb-12 md:mb-16">
          <div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-foreground-900 font-heading leading-tight">
              最新<span className="text-accent-500">爆料</span>
            </h2>
            <p className="text-foreground-500 text-base mt-3">
              黑料每日更新，吃瓜不停歇
            </p>
          </div>
          <Link
            to="/"
            className="hidden sm:inline-flex items-center gap-2 text-primary-600 font-medium text-sm hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <span className="text-primary-600 text-xs font-medium bg-primary-50 px-2.5 py-1 rounded-full">
                  {article.category}
                </span>
                <h3 className="text-foreground-900 font-bold text-sm md:text-base mt-3 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs mt-2 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/70">
                  <span className="text-foreground-400 text-xs">{article.date}</span>
                  <span className="text-foreground-400 text-xs flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Mobile view all link */}
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-primary-600 font-medium text-sm hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}